<template lang="pug">
.v-map-page.map-page(v-if="data")
	.map-page__aside(v-if="!isSm" )
		.map-page__aside-wrap(v-if="data.items")
			v-filter(ref="filter"
				:filters="data.filters"
				@filter-changed="filterChanged")
			.map-page__aside-cards
				v-map-aside-card.map-page__aside-card.flc(
					v-for="(card, index) in data.items"
					:active-id="activeId"
					@active-marker="setActiveMarker"
					:key="index"
					:data-source="card")
	button.map-page__filter.btn(
			v-if="isSm && data.button"
			@click="showForm")
		| {{ data.button?.text }}
	v-map-google.map-page__map(:init-params="data.initParams" :items="data.items" :active-marker="activeMarker" @active-id="setActiveId")

	.map-page__aside-modal
		transition(name="show-aside")
			.aside-modal(v-if="filterOpen ")
				.aside-modal__overlay(@click.stop="closeForm")
				.aside-modal__inner.scrollbar(v-if="data.filters")
					.aside-modal__head(v-if="data.variables" )
						.aside-modal__title(v-if="data.variables.filterTitle" ) {{data.variables.filterTitle }}
						button.aside-modal__close(@click.stop="closeForm")
							v-svg-icon.aside-modal__close-icon(icon="cross")
					.aside-modal__body
						v-filter(ref="filter"
							:filters="data.filters"
							@filter-changed="filterChanged")
						button.map-page__filter-btn.btn(v-if="data.buttonFilter" @click="closeForm")
							span.map-page__filter-btn--text(v-if="data.buttonFilter.text" ) {{ data.buttonFilter?.text }}&nbsp
							span.map-page__filter-btn--count(v-if="data.buttonFilter.count" ) {{ data.buttonFilter.count }}
		transition(name="show-aside")
			.aside-modal(v-if="cardsOpen  && !isSm")
				.aside-modal__overlay(@click.stop="closeCards")
				.aside-modal__inner.scrollbar(v-if="data.items")
					.aside-modal__head(v-if="data.variables" )
						.aside-modal__title(v-if="data.variables.cardsTitle" ) {{data.variables.cardsTitle }}
						button.aside-modal__close(@click.stop="closeCards")
							v-svg-icon.aside-modal__close-icon(icon="cross")
					.aside-modal__body
						.aside-modal__body-cards
							v-map-aside-card.map-page__aside-card.flc(
								v-for="(card, index) in data.items"
								:active-id="activeId"
								@active-marker="setActiveMarker"
								:key="card.id || index"
								:data-source="card")
		transition(name="show-aside")
			.aside-modal(v-if="activeCardOpen && isSm ")
				.aside-modal__overlay(@click.stop="closeAciveCard")
				.aside-modal__inner.scrollbar(v-if="data.items")
					.aside-modal__head(v-if="data.variables" )
						.aside-modal__title(v-if="data.variables.cardsTitle" ) {{data.variables.cardsTitle }}
						button.aside-modal__close(@click.stop="closeAciveCard")
							v-svg-icon.aside-modal__close-icon(icon="cross")
					.aside-modal__body
						.aside-modal__body-cards
							v-map-aside-card.map-page__aside-card.flc(:data-source="data.items.find(item => item.id === activeId )")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import smoothScrollTo from "../scripts/helpers/smoothScrollTo.js";
import scrollLock from "scroll-lock";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			filter: null,
			filterOpen: false,
			cardsOpen: false,
			activeCardOpen: null,
			activeId: null,
			activeMarker: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		setActiveMarker(id) {
			this.activeMarker = id
		},

		setActiveId(id) {
			this.activeId = id
			this.scrollActive();
			if(this.isSm) {
				this.showAciveCard()
			}
		},
		getCoords(elem) {
			let box = elem.getBoundingClientRect();

			return {
				top: box.top + window.pageYOffset,
				right: box.right + window.pageXOffset,
				bottom: box.bottom + window.pageYOffset,
				left: box.left + window.pageXOffset
			};
		},
		scrollActive() {
			this.$nextTick(() => {
				const el = document.querySelector('.map-aside-card.active')
				const parentEl = document.querySelector('.map-page__aside-cards')
				const HEADER_HEIGHT = 348.4

				const {top: elTop} = this.getCoords(el);
				const parentElementTop = parentEl.scrollTop;
				const to = elTop - HEADER_HEIGHT
				smoothScrollTo(to + parentElementTop, 300, parentEl, null);
			})

		},

		filterChanged(filterValue) {
			this.filter = filterValue;
			this.requestDataLoad();
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					filter: this.filter
				}
			}, dataSetOptions);
		},

		showForm() {
			this.filterOpen = true;
			// scrollLock.enablePageScroll();
			this.$nextTick(() => {
				scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
			})
		},

		closeForm() {
			this.filterOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},

		showCards() {
			this.cardsOpen = true;
			// scrollLock.enablePageScroll();
			this.$nextTick(() => {
				scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
			})

		},

		closeCards() {
			this.cardsOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},

		showAciveCard() {
			this.activeCardOpen = true;
			// scrollLock.enablePageScroll();
			this.$nextTick(() => {
				scrollLock.disablePageScroll(document.querySelectorAll('.aside-modal__inner'));
			})

		},

		closeAciveCard() {
			this.activeCardOpen = false;
			scrollLock.enablePageScroll(document.querySelectorAll('.aside-modal__inner'));
		},
	}
}

</script>